<template>
  <div class="snackbar show danger" v-if="error.visible">
    <p>{{ error.message }}</p>
    <button @click="hideError">X</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ErrorSnackBar',
  computed: {
    ...mapGetters({
      error: 'error/error',
    }),
  },
  methods: {
    ...mapActions({
      hideError: 'error/hideError',
    }),
  },
};
</script>

<style lang="scss" scoped>
.snackbar {
  border-left: 7px solid #900f0f;
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  left: 50%; /* Center the snackbar */
  bottom: 30px; /* 30px from the bottom */
  z-index: 999999;
  & p {
    font-size: 13px;
    color: #fff;
    letter-spacing: 1.11px;
    font-family: Fira Code, sans-serif;
  }
  & button {
    background: transparent;
    border: 0;
    font-size: 13px;
    color: #fff;
  }
}

.danger {
  background-color: #ef2f2f;
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
.show {
  visibility: visible !important; /* Show the snackbar */

  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;
}
/* Show the snackbar when clicking on a button (class added with JavaScript) */
.hide {
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadeout 1.5s 3.5s;
  animation: fadeout 1.5s 3.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
</style>
